const CONSENT_COOKIE_NAME = 'consent_status';
const CONSENT_MODAL_ID = 'consentModal';
const BANNER_STORAGE_KEY = 'banner';
const DEFAULT_CONSENT = { ad_storage: true, analytics_storage: true };

const getCookieOptions = () => {
  const expires = new Date();
  expires.setMonth(expires.getMonth() + 3);
  const domainLang = (() => {
    const lang = process.env.GATSBY_LANG;

    switch (lang) {
      case 'de':
        return 'de';
      case 'ae':
        return 'ae';
      case 'az':
        return 'az';
      case 'uk':
        return 'co.uk';
      case 'kz':
        return 'kz';
      case 'pl':
        return 'pl';
      case 'fr':
        return 'fr';
      case 'nl':
        return 'nl';
      default:
        return 'com';
    }
  })();

  const domain =
    window.location.hostname === 'localhost' ? 'localhost' : `andersenlab.${domainLang}`;

  return { expires, domain };
};

export {
  CONSENT_COOKIE_NAME,
  CONSENT_MODAL_ID,
  getCookieOptions,
  BANNER_STORAGE_KEY,
  DEFAULT_CONSENT,
};
